import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateService } from '../date/date.service';
import { Content } from 'pdfmake/interfaces';
import { OrderDetails } from '@pages/common-order/_interfaces_/order-details.interface';
import { DateFormatEnum } from '../../../core/enums/date-format.enum';

@Injectable({
  providedIn: 'root',
})
export class OrderDetailsPdfService {
  constructor(private translateService: TranslateService, private dateService: DateService) {}

  public getContent(orderDetails: OrderDetails): Content[] {
    const orderNumber = orderDetails.orderNumber || '-';
    const orderStatus = orderDetails.status || '-';
    const orderExpiryDate = orderDetails.optionExpiryDateTime
      ? this.dateService.formatDateTime(orderDetails.optionExpiryDateTime.toString(), DateFormatEnum.PDFdMMMyyyy)
      : '-';
    const orderStatusExpiryDate = orderDetails.optionExpiryDateTime
      ? this.dateService.formatDateTime(orderDetails.optionExpiryDateTime.toString(), DateFormatEnum.PDFdMMMyyyyHHmm)
      : '-';

    const content = [
      {
        columns: [
          { text: [{ text: `${this.translateService.instant('PRINT.ORDER_NUMBER')}\n`, bold: true }, orderNumber] },
          { text: [{ text: `${this.translateService.instant('PRINT.ORDER_DATE')}\n`, bold: true }, orderExpiryDate] },
          {
            text: [
              { text: `${this.translateService.instant('PRINT.ORDER_STATUS')}\n`, bold: true },
              `${orderStatus} ${orderStatusExpiryDate}`,
            ],
          },
        ],
      },
      { text: '\n\n\n' },
    ];

    return content;
  }
}
